import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormGroup} from '@angular/forms';

@Component({
  selector: 'comboTools',
  templateUrl: 'comboTools.template.html',
  styleUrls: ['./comboTools.component.css'],
  
})
export class ComboToolsComponent implements OnInit, OnChanges {

  @Input() Errors: boolean=false;
  @Input() list: any;
  @Input() selected: any;
  @Input() formControlName: any;
  @Input() filter: any;
  @Input() required: boolean=false;
  @Input() isEditing: boolean=false;
  @Input() formParent: FormGroup;
  @Input() ph: string;
  @Input() AppendMydiv: string;
  @Input() soloCodigo: boolean=false;
  @Input() soloDescri: boolean=false;
  
  
  @Output() SelectedChange = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
     //this.isEditing = false;
     if(!this.ph)
     {
        this.ph=this.selected.replace(/([A-Z])/g, ' $1').replace(/^./, function(str) {
          return str.toUpperCase(); }).trim();
     }
  }
 
  ngOnChanges(changes: SimpleChanges) {
    
  }

  public onChangeCombo(e):void {
    this.SelectedChange.emit(e);
  }

}
